import React, { useState } from "react";
import "../../Styles/AuthStyle.css";
// import "./SignIn.css";
import {
  FormWrapper,
  FormInputRow,
  FormMessage,
  FormTitle,
  PageLink,
  Button,
  FormLabel,
  FormInput,
} from "../../components/StyledComp/StyledComp";

import AdminUserService from "../../services/adminUserServices";
import { Link, useNavigate, useParams } from "react-router-dom";
import SignInLogo from "../../pages/auth/SignInLogo";
import { isShowLoader } from "../../store/apiSlice";
import { useDispatch } from "react-redux";
import LoaderComponent from "../../components/StyledComp/Loader";
interface IState {
  user: {
    email: string;
  };
}

const ForgotPassword: React.FC = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [state, setState] = useState<IState>({
    user: {
      email: "",
    },
  });
  const dispatch = useDispatch();

  const { verificationString } = useParams();
  console.log("verificationString", verificationString);

  const messageVariants = {
    hidden: { y: 30, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { delay: 0.2, duration: 0.4 } },
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // console.log("updateinput  ", state);
    // console.log("updateinput1  ", event.target.name);
    setState({
      user: {
        ...state.user,
        [event.target.name]: event.target.value,
      },
    });
  };

  const setPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    console.log("setPassword");
    dispatch(isShowLoader(true));
    event.preventDefault();
    const response = await AdminUserService.forGotPasswordSendLink(
      state.user.email
    );
    console.log("response", response);
    if (response.data.data != null) {
      alert("Check your mail to reset password");
      dispatch(isShowLoader(false));
      navigate("/sign-in", { replace: false });
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      setError(response.data.errors);
    }
  };

  const formData = [
    {
      label: "Email",
      name: "email",
      placeHolder: "Enter your email",
      value: state.user.email,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        updateInput(event),
      type: "email",
    },
  ];

  return (
    <div className="signin-wrapper">
      <LoaderComponent />
      <div className="signin col-12 col-lg-8">
        <div className="signin-logo col-12 col-lg-5">
          <SignInLogo />
        </div>

        {/* Sign In section */}
        <div className="signin-form col-12 col-lg-7">
          <div>
            <FormTitle>Forgot Password</FormTitle>
            <FormWrapper onSubmit={(e) => setPassword(e)}>
              {formData.map((el, index) => (
                <FormInputRow key={index}>
                  <FormLabel>{el.label}</FormLabel>
                  <FormInput
                    type={el.type}
                    name={el.name}
                    placeholder={el.placeHolder}
                    value={el.value}
                    required
                    // onChange={(event: React.ChangeEvent<HTMLInputElement>) => updateInput(event)}
                    onChange={(
                      event: React.ChangeEvent<HTMLInputElement>
                    ): void => updateInput(event)}
                  />
                </FormInputRow>
              ))}
              <div className="loginbutton">
                <Button type="submit">Confirm</Button>
              </div>
              <Link to="/sign-in" className="page-link">
                {" "}
                <PageLink>Sign In</PageLink>{" "}
              </Link>
            </FormWrapper>
            {error && (
              <FormMessage
                className="ErrorDiv"
                variants={messageVariants}
                initial="hidden"
                animate="animate"
              >
                {error}
              </FormMessage>
            )}
            {/* {success && (
              <FormMessage
                variants={messageVariants}
                initial="hidden"
                animate="animate"
                error={false}
              >
                {success}
              </FormMessage> 
            )}  */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
